import { render, staticRenderFns } from "./ArtCanvas.vue?vue&type=template&id=02b3c282&"
import script from "./ArtCanvas.vue?vue&type=script&lang=js&"
export * from "./ArtCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports